/* -----------------Child components--------------- */
import CustomAppbar from "components/CustomAppbar";

import { appBarMeta } from "@constants/appbar";
import { pageViewTypes } from "@constants/tracking";
/* -----------------Features--------------- */
import LeaderboardContainer from "@features/dashboard/screens/LeaderboardContainer";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import { useDevice } from "@hooks/useDevice";
import DocumentTitle from "components/DocumentTitle";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const LeaderboardRoute = () => {
	const { isMobile } = useDevice();

	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.leaderboard,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	const { t } = useTranslation();
	return (
		<>
			<CustomAppbar
				showCommandBar={isWeb}
				showHambugerMenu
				options={{
					headerTitle: t(appBarMeta.leaderboard.title),
					subtitle: isMobile ? "" : t(appBarMeta.leaderboard.description),
				}}
				role="banner"
			/>
			<DocumentTitle title="Leaderboard" />
			<LeaderboardContainer />
		</>
	);
};

export default LeaderboardRoute;
